import { makeStyles } from '@material-ui/core/styles';

const overlayLoaderStyles = makeStyles(theme => ({
  loaderContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'block',
    background: theme.palette.common.white,
    opacity: 0.85,
  },
  progressContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
}));

export default overlayLoaderStyles;
